import { createApi } from '@reduxjs/toolkit/query/react';
import { axiosBaseQuery } from '../rtkQuery';
import { restApiFormData } from '../axios';
import { API_ENDPOINTS } from '../constants';

export const rolesAPI = createApi({
    reducerPath: 'rolesAPI',
    baseQuery: axiosBaseQuery(restApiFormData),
    endpoints: (builder) => ({
        searchRoles: builder.mutation({
            query: (query) => ({
                url: `${API_ENDPOINTS.SEARCH_ROLE}?${query.toString()}`,
                method: 'POST',
            }),
        }),
        listRoles: builder.mutation({
            query: (query) => ({
                url: `${API_ENDPOINTS.LIST_ROLES}?${query.toString()}`,
                method: 'POST',
            }),
        }),
        createRole: builder.mutation({
            query: (data) => ({
                url: API_ENDPOINTS.CREATE_ROLE,
                method: 'POST',
                data,
            }),
        }),
        modifyRole: builder.mutation({
            query: (data) => ({
                url: API_ENDPOINTS.MODIFY_ROLE,
                method: 'POST',
                data,
            }),
        }),
        saveRole: builder.mutation({
            query: (data) => ({
                url: API_ENDPOINTS.SAVE_ROLE,
                method: 'POST',
                data,
            }),
        }),
        modifyRoleAction: builder.mutation({
            query: (data) => ({
                url: API_ENDPOINTS.MODIFY_ROLE_ACTION,
                method: 'POST',
                data,
            }),
        }),
        deleteRole: builder.mutation({
            query: (data) => ({
                url: API_ENDPOINTS.DELETE_ROLE,
                method: 'POST',
                data,
            }),
        }),
        viewRole: builder.mutation({
            query: (data) => ({
                url: API_ENDPOINTS.VIEW_ROLE,
                method: 'POST',
                data,
            }),
        }),
    }),
});

export const {
    useSearchRolesMutation,
    useListRolesMutation,
    useCreateRoleMutation,
    useModifyRoleMutation,
    useSaveRoleMutation,
    useModifyRoleActionMutation,
    useDeleteRoleMutation,
    useViewRoleMutation,
} = rolesAPI;
